import { open_shell } from "./index.js";
import { conditional_reverse, } from "../ap214_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class oriented_open_shell extends open_shell {
    get type() {
        return EntityTypesAP214.ORIENTED_OPEN_SHELL;
    }
    get open_shell_element() {
        if (this.open_shell_element_ === void 0) {
            this.open_shell_element_ = this.extractElement(2, false, open_shell);
        }
        return this.open_shell_element_;
    }
    get orientation() {
        if (this.orientation_ === void 0) {
            this.orientation_ = this.extractBoolean(3, false);
        }
        return this.orientation_;
    }
    get cfs_faces() {
        return conditional_reverse(this?.orientation, this?.open_shell_element.cfs_faces);
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
oriented_open_shell.query = [EntityTypesAP214.ORIENTED_OPEN_SHELL];
oriented_open_shell.expectedType = EntityTypesAP214.ORIENTED_OPEN_SHELL;
